export {MessagesQuickSearch as default};

/**
* Messages Quick Search params
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessagesQuickSearch {
	/**
   * Search Type
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  qs = 'quicksearch';

  /**
   * Search Value
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  qsearch;

  /**
   * Search Field
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  qsearchfield = 'subject';

  /**
   * Folder Id
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  qsearchmbox;

  /**
   * Sets all QuickSearch Params from a query string object
   *
   * @public
   *
   * @param {MessagesQuickSearch} quick_search
   * @param {Object}              query_string
   *
   * @since 7.0.0
   */
  setFromQueryString(quick_search, query_string) {
    if (!query_string || query_string.qs !== 'quicksearch') {
      return;
    }

    quick_search = Object.assign(quick_search, query_string);
  }
}